import { ContactDetails } from '@/models/common/contact-details';
import { FrontPageImage, FrontPageImageType } from '@/models/common/front-page-image';
import { Link, LinkType } from '@/models/common/link';
import { PublicationStatusInfo } from '@/models/common/publication-status-info';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class AssociationFrontPage {
    public id: number = 0;
    public associationId: number = 0;
    public publicationStatus: PublicationStatusInfo[] = [];
    public isTemporary: boolean = false;
    public images: FrontPageImage[] = [];
    public claim?: string;
    public subclaim?: string;
    public metaClaim?: string;
    public description?: string;
    public socialMediaLinks: Link[] = [];
    public slug?: string;
    public otherLinks: Link[] = [];
    public contactDetails: ContactDetails = new ContactDetails();

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Associations;
    }

    public get permissionsIdToCheck(): number {
        return this.associationId;
    }

    get hasAtLeastOneFrontPagePublished(): boolean {
        return this.publicationStatus.some((p) => p.isPublished);
    }

    constructor(json?: any) {
        if (!json) {
            this.description = '';
            return;
        }

        Object.assign(
            this,
            json,
            { publicationStatus: json.publicationStatus ? json.publicationStatus.map((status: any) => new PublicationStatusInfo(status)) : [] },
            { images: json.images ? json.images.map((image: any) => new FrontPageImage(image)) : [] },
            { socialMediaLinks: json.socialMediaLinks ? json.socialMediaLinks.map((link: any) => new Link(link)) : [] },
            { otherLinks: json.otherLinks ? json.otherLinks.map((link: any) => new Link(link)) : [] },
            { contactDetails: new ContactDetails(json.contactDetails) });

        if (!this.description || this.description === '') {
            this.description = '';
        } else {
            const Entities = require('html-entities').AllHtmlEntities;
            const entities = new Entities();

            this.description = entities.decode(this.description);
        }
    }

    public imageWasChanged(type: FrontPageImageType, newUrl: string): boolean {
        const image = this.images.find((image) => image.type === type);

        if (image) {
            return image.url !== newUrl;
        }

        return !newUrl.startsWith('/img/');
    }

    public setImageUrl(type: FrontPageImageType, newUrl: string) {
        const image = this.images.find((image) => image.type === type);

        if (image) {
            image.url = newUrl;
        } else {
            this.images.push(new FrontPageImage({ type, url: newUrl }));
        }
    }

    public initSocialMediaLinks(): void {
        for (const socialMediaTypeProperty in LinkType) {
            if (isNaN(Number(socialMediaTypeProperty)) && socialMediaTypeProperty !== LinkType[LinkType.Other]) {
                const socialMediaName = socialMediaTypeProperty;
                const socialMediaIndex = LinkType[socialMediaTypeProperty];
                if (this.socialMediaLinks.find((link) => LinkType[link.type!] === socialMediaName) === undefined) {
                    this.socialMediaLinks.push(new Link({ url: '', type: socialMediaIndex }));
                }
            }
        }

        this.orderSocialMediaLinks();
    }

    private orderSocialMediaLinks() {
        if (this.socialMediaLinks && this.socialMediaLinks.length > 0) {
            this.socialMediaLinks.splice(0, 0, this.socialMediaLinks.splice(this.socialMediaLinks.findIndex((element: Link) => element.type === LinkType.WhatsApp), 1)[0]);
            this.socialMediaLinks.splice(10, 0, this.socialMediaLinks.splice(this.socialMediaLinks.findIndex((element: Link) => element.type === LinkType.MyWebSite), 1)[0]);
            this.socialMediaLinks.splice(10, 0, this.socialMediaLinks.splice(this.socialMediaLinks.findIndex((element: Link) => element.type === LinkType.MyOnlineShop), 1)[0]);
        }
    }
}
